import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import alphaLogo from '../../assets/logo.png';

const Navbar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="absolute top-0 left-0 right-0 z-40 bg-transparent">
      <div className="mx-auto px-4 sm:px-8 lg:px-16 xl:px-24">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo/Brand - Mobile optimized */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-2">
              <img src={alphaLogo} alt="Alpha AI" className="h-12 w-auto" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6">
            <Link
              to="/explore"
              className="text-black hover:text-gray-600 transition-colors capitalize"
              style={{
                fontFamily: 'Poppins',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '24px'
              }}
            >
              Explore
            </Link>
            <Link
              to="/monitor"
              className="text-black hover:text-gray-600 transition-colors capitalize"
              style={{
                fontFamily: 'Poppins',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '24px'
              }}
            >
              Monitor
            </Link>
            <Link
              to="/news"
              className="text-black hover:text-gray-600 transition-colors capitalize"
              style={{
                fontFamily: 'Poppins',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '24px'
              }}
            >
              News
            </Link>
            <Link
              to="/about"
              className="text-black hover:text-gray-600 transition-colors capitalize"
              style={{
                fontFamily: 'Poppins',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '24px'
              }}
            >
              About
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 text-black hover:text-gray-600 touch-manipulation"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation - Improved with better touch targets */}
        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-black bg-white">
            <div className="py-2 space-y-1">
              <Link
                to="/explore"
                className="block px-4 py-3 text-black hover:bg-gray-100 touch-manipulation transition-colors capitalize"
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontSize: '16px',
                  lineHeight: '24px'
                }}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Explore
              </Link>
              <Link
                to="/monitor"
                className="block px-4 py-3 text-black hover:bg-gray-100 touch-manipulation transition-colors capitalize"
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontSize: '16px',
                  lineHeight: '24px'
                }}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Monitor
              </Link>
              <Link
                to="/news"
                className="block px-4 py-3 text-black hover:bg-gray-100 touch-manipulation transition-colors capitalize"
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontSize: '16px',
                  lineHeight: '24px'
                }}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                News
              </Link>
              <Link
                to="/about"
                className="block px-4 py-3 text-black hover:bg-gray-100 touch-manipulation transition-colors capitalize"
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontSize: '16px',
                  lineHeight: '24px'
                }}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;